export const createAnimation = (yValue, dur) => ({
  initial: { opacity: 0, y: yValue },
  animate: { opacity: 1, y: 0 },
  transition: { duration: dur, ease: 'easeOut' },
})
